<div class="n-panel" style="margin-top: 12px;">
  <div class="el-fej">
    <button type="button" class="ov-gomb" (click)="valt()">
      <ion-icon [name]="nyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>{{ cim }}
    </button>
    <span class="spacer" style="flex:1"></span>
    <span class="el-osszeg" *ngIf="elonezet && nyitva">
      {{ elonezet.db }} átutalás · <b>{{ elonezet.osszeg | number:'1.0-0' }} Ft</b>
    </span>
    <button type="button" class="ov-gomb fo" *ngIf="nyitva" [disabled]="!elonezet?.db || tolt" (click)="letolt()">
      <ion-icon name="download-outline"></ion-icon>{{ elonezet?.fajlnev || '.HUF' }} letöltése
    </button>
  </div>

  <ng-container *ngIf="nyitva">
    <div class="ures" *ngIf="hibaSzoveg"><ion-icon name="alert-circle-outline"></ion-icon>{{ hibaSzoveg }}</div>

    <ng-container *ngIf="elonezet">
      <div class="halvany" style="font-size:.84rem; margin-top:8px;">
        Kötelezett: <b>{{ elonezet.kuldo.nev }}</b> · {{ elonezet.kuldo.szamla }} ·
        a fájl {{ elonezet.sorHossz }} karakteres sorokból áll (Electra kötött formátum, EDIFACT PAYORD).
      </div>

      <!-- Beállítások: az értéknap a gyakori, a többi ritkán kell -->
      <div class="el-beall">
        <div class="mezo">
          <label>Értéknap</label>
          <input type="date" [(ngModel)]="beall.nap" (change)="valtozott()" />
        </div>
        <div class="mezo" *ngIf="fajta === 'ber'">
          <label>Kifizetés</label>
          <select [(ngModel)]="beall.tipus" (change)="valtozott()">
            <option value="">mind</option>
            <option value="havi">havi zárás</option>
            <option value="hokozi">hóközi</option>
          </select>
        </div>
        <button type="button" class="ov-gomb" (click)="beallLatszik = !beallLatszik">
          <ion-icon name="options-outline"></ion-icon>Formátum
        </button>
        <ng-container *ngIf="beallLatszik">
          <div class="mezo">
            <label>Kódlap</label>
            <select [(ngModel)]="beall.kodlap" (change)="valtozott()">
              <option value="latin2">ISO-8859-2 (Latin-2)</option>
              <option value="cp852">CP852 (DOS)</option>
              <option value="utf8">UTF-8</option>
            </select>
          </div>
          <div class="mezo">
            <label>Ékezet</label>
            <select [(ngModel)]="beall.ekezet" (change)="valtozott()">
              <option [ngValue]="true">megtartva</option>
              <option [ngValue]="false">ékezet nélkül</option>
            </select>
          </div>
          <div class="mezo">
            <label>Számlaszám igazítás</label>
            <select [(ngModel)]="beall.szamlaigazitas" (change)="valtozott()">
              <option value="bal">balra (24 jegy + szóköz)</option>
              <option value="jobb">jobbra (nullákkal)</option>
            </select>
          </div>
          <div class="mezo">
            <label>Megbízás</label>
            <select [(ngModel)]="beall.megbizas" (change)="valtozott()">
              <option value="">normál</option>
              <option value="V">VIBER</option>
              <option value="T">T+1</option>
            </select>
          </div>
        </ng-container>
      </div>

      <div class="el-fig" *ngFor="let f of elonezet.figyelmeztetes">
        <ion-icon name="warning-outline"></ion-icon> {{ f }}
      </div>

      <div class="tabla-wrap" *ngIf="elonezet.sorok.length">
        <table class="n-racs">
          <thead><tr><th>Kedvezményezett</th><th>Bankszámlaszám</th><th>Közlemény</th><th>Értéknap</th><th class="num">Összeg</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of elonezet.sorok">
              <td>{{ s.cimzettNev }}<span class="cimke" *ngIf="s.ugyszam" [title]="'Ügyszám'">{{ s.ugyszam }}</span></td>
              <td>{{ s.szamlaNyers || s.cimzettSzamla }}
                <span class="cimke piros" *ngIf="s.cdvOk === false" title="A számlaszám ellenőrző számjegye hibás – a bank elutasíthatja">CDV?</span>
              </td>
              <td class="n-ket-sor">{{ s.kozlemeny }}</td>
              <td>{{ s.ertekNap }}</td>
              <td class="num">{{ s.osszeg | number:'1.0-0' }}</td>
            </tr>
          </tbody>
          <tfoot><tr><td colspan="4">Összesen</td><td class="num">{{ elonezet.osszeg | number:'1.0-0' }}</td></tr></tfoot>
        </table>
      </div>
      <div class="ures" *ngIf="!elonezet.sorok.length"><ion-icon name="card-outline"></ion-icon>Nincs átutalható tétel ebben a hónapban.</div>

      <!-- Ami kimarad: ezt kézzel kell rendezni, ezért nem elég némán kihagyni -->
      <div *ngIf="elonezet.kimaradt?.length" style="margin-top:10px;">
        <div class="n-panel-cim">Kimaradt a csomagból ({{ elonezet.kimaradt.length }})</div>
        <div class="el-kimaradt" *ngFor="let k of elonezet.kimaradt">
          {{ k.nev }}<ng-container *ngIf="k.alkalmazott"> ({{ k.alkalmazott }})</ng-container>
          – {{ k.osszeg | number:'1.0-0' }} Ft: {{ k.ok }}
        </div>
      </div>

      <div style="margin-top:10px;" *ngIf="elonezet.minta">
        <button type="button" class="ov-gomb" (click)="mintaLatszik = !mintaLatszik">
          <ion-icon name="code-outline"></ion-icon>{{ mintaLatszik ? 'Minta elrejtése' : 'Első rekord megtekintése' }}
        </button>
        <div class="el-minta" *ngIf="mintaLatszik" style="margin-top:8px;">{{ elonezet.minta }}</div>
        <div class="halvany" *ngIf="mintaLatszik" style="font-size:.76rem; margin-top:4px;">
          A · jel szóközt jelöl. A mezők fix pozíción állnak; a bank súgójában nem szereplő pozíciók üresek.
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
